import { render, staticRenderFns } from "./single-choice.vue?vue&type=template&id=06ac2d32&scoped=true&"
import script from "./single-choice.vue?vue&type=script&lang=js&"
export * from "./single-choice.vue?vue&type=script&lang=js&"
import style0 from "./single-choice.vue?vue&type=style&index=0&id=06ac2d32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ac2d32",
  null
  
)

export default component.exports